import { CSSProperties, FC } from 'react';
import { Thumbnail } from 'react-pdf';
import cn from 'classnames';

import { Container, StyledText } from './styled';

type ThumbnailItemProps = {
  index: number;
  style: CSSProperties;
  data: {
    thumbnailWidth: number;
    activePage: number;
    setActivePage: (n: number) => void;
  };
};

export const ThumbnailItem: FC<ThumbnailItemProps> = ({ index, style, data }) => {
  return (
    <div style={style}>
      <Container
        className={cn({ active: data.activePage === index })}
        onClick={() => data.setActivePage(index)}
      >
        <Thumbnail devicePixelRatio={1} pageIndex={index} width={data.thumbnailWidth} />
        <StyledText>{index + 1}</StyledText>
      </Container>
    </div>
  );
};
